import React from 'react';

const PlaceholderContext = React.createContext({});

export const PlaceholderProvider = PlaceholderContext.Provider;
export const PlaceholderConsumer = PlaceholderContext.Consumer;
